import type {
  ExistingSystemDetails,
  FirstSystemOwnership,
} from "../../../../../amplify/backend/function/OfferExpUsage/ts/public/types";

const DEFAULT_PREFERRED_LANGUAGE = "English";

const CUSTOMER_INFO_LABELS = {
  language: "Customer’s language preference",
  solarPanels: "The customer’s home has solar panels installed",
  existingSystemDetails: "Select existing system details:",
  utilityCompany: "Utility company",
  homeType: "Home type",
} as const;

const ADDITIONAL_SYSTEM_OPTIONS = {
  yes: { label: "Yes, solar panels installed", value: true },
  no: {
    label: "No solar panels installed",
    value: false,
  },
} as const;

/** Composite UI values; mapped to prospect existingSystemDetails + firstSystemOwnership on save. */
const EXISTING_SYSTEM_DETAILS_OPTIONS = [
  { label: "RUN: solar only", value: "RUN: solar only" },
  { label: "RUN: solar + backup", value: "RUN: solar + backup" },
  { label: "Non-RUN: solar only", value: "Non-RUN: solar only" },
  { label: "Non-RUN: solar + backup", value: "Non-RUN: solar + backup" },
] as const;

type ExistingSystemDetailsOptionValue =
  (typeof EXISTING_SYSTEM_DETAILS_OPTIONS)[number]["value"];

const getAdditionalSystemLabel = (hasAdditionalSystem: boolean) =>
  hasAdditionalSystem
    ? ADDITIONAL_SYSTEM_OPTIONS.yes.label
    : ADDITIONAL_SYSTEM_OPTIONS.no.label;

const toExistingSystemDetailsOption = (
  existingSystemDetails?: ExistingSystemDetails,
  firstSystemOwnership?: FirstSystemOwnership
): ExistingSystemDetailsOptionValue | "" => {
  if (!existingSystemDetails && !firstSystemOwnership) {
    return "";
  }
  const ownership = firstSystemOwnership === "Sunrun" ? "RUN" : "Non-RUN";
  const system =
    existingSystemDetails === "Solar + Storage"
      ? "solar + backup"
      : "solar only";
  return `${ownership}: ${system}` as ExistingSystemDetailsOptionValue;
};

const fromExistingSystemDetailsOption = (
  option: string
): {
  existingSystemDetails: ExistingSystemDetails;
  firstSystemOwnership: FirstSystemOwnership;
} => ({
  existingSystemDetails: option.includes("backup")
    ? "Solar + Storage"
    : "Solar only",
  firstSystemOwnership: option.includes("Non-RUN") ? "Other" : "Sunrun",
});

export {
  DEFAULT_PREFERRED_LANGUAGE,
  CUSTOMER_INFO_LABELS,
  ADDITIONAL_SYSTEM_OPTIONS,
  EXISTING_SYSTEM_DETAILS_OPTIONS,
  getAdditionalSystemLabel,
  toExistingSystemDetailsOption,
  fromExistingSystemDetailsOption,
};
export type { ExistingSystemDetailsOptionValue };
